export enum FaqFilterType {
  All = 1,
  Shared = 2,
  GameSpecific = 3
}
